import config from '../../config';

export const CASSIE_PWA_PROTOCOL_URL = config.cassieWebsocketProtocol;
